import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiInputDateRangeModule, TuiTagModule } from '@taiga-ui/legacy';
import { TuiNotification, TuiScrollbar, TuiScrollable } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NewListModule } from '@src/app/modules/list';
import { ComponentsModule } from '@src/app/components';
import { BannerModule } from '@src/app/modules/banner';

import { ListComponent } from './components/list/list.component';
import { BannerComponent } from './components/banner/banner.component';
import { BirthdaysApiService } from './services';
import { TagComponent } from './components/tag/tag.component';

@NgModule({
  declarations: [ListComponent, BannerComponent, TagComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TuiNotification,
    RouterModule,
    TranslateModule,
    NewListModule,
    TuiScrollbar,
    TuiScrollable,
    TuiTagModule,
    TuiInputDateRangeModule,
    TuiTextfieldControllerModule,
    ComponentsModule,
    BannerModule,
    NgxPermissionsModule,
  ],
  providers: [BirthdaysApiService],
  exports: [ListComponent, BannerComponent],
})
export class BirthdaysModule {}
